// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 19-design-system.md
import { FlaskConical } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuCheckboxItem,
} from '@/components/ui/dropdown-menu';
import {
  PREVIEW_FEATURES,
  PREVIEW_FEATURE_KEYS,
  isPreviewBuild,
  isPreviewFeatureEnabled,
  setPreviewFeatureEnabled,
} from '@/lib/preview-features';

export function PreviewFeaturesMenu() {
  if (!isPreviewBuild()) return null;

  // Preview flags are read at render time across the app, so flipping one reloads.
  const togglePreview = (feature: (typeof PREVIEW_FEATURE_KEYS)[number]) => {
    setPreviewFeatureEnabled(feature, !isPreviewFeatureEnabled(feature));
    window.location.reload();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Preview features"
          data-testid="preview-features-menu"
        >
          <FlaskConical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
          Preview features
        </DropdownMenuLabel>
        {PREVIEW_FEATURE_KEYS.map((feature) => (
          <DropdownMenuCheckboxItem
            key={feature}
            checked={isPreviewFeatureEnabled(feature)}
            onCheckedChange={() => togglePreview(feature)}
            title={PREVIEW_FEATURES[feature].description}
          >
            {PREVIEW_FEATURES[feature].label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
